<template lang="pug">
  #app
    audio#ding(:src="assetsUrl + '/ding.mp3'")
    audio#start(:src="assetsUrl + '/send_start.mp3'")
    audio#error(:src="assetsUrl + '/send_error.mp3'")
    audio#success(:src="assetsUrl + '/send_success.mp3'")
    article(v-if="messenger", :style="{ backgroundColor: messenger.appearance.primary_color }")
      header
        .offset
          avatar(:person="messenger.greeter", :borderColor="messenger.appearance.primary_color")
          .name
            h2 {{ messenger.greeter.name }}

      .content
        //-button(@click="play = true", type="button") play
        router-view
</template>

<script>

import api from './services/api'
import socket from './services/socket'

import { mapGetters, mapActions } from 'vuex'

import avatar from '@/components/Avatar'

export default {
  name: 'app',
  components: {
    avatar
  },
  data () {
    return {
      companyId: this.$route.params.companyId,
      referrer: this.$route.query.page,
      assetsUrl: (process.env.NODE_ENV === 'production') ? '/breezy-widget/static' : '/static'
    }
  },
  created () {
    console.log('created', this.$route.query)
    api.init(this.$route.query.APP_BASE_URL)
    socket.init(this.$route.query.socketUrl)
    this.$store.dispatch('getMessenger', this.companyId)
  },
  computed: {
    ...mapGetters(['messenger', 'candidate'])
  },
  methods: {
  }
}
</script>

<style lang="stylus">
@import('./assets/styles/_constants.styl')
@import('./assets/styles/reset.css')

@import url('https://fonts.googleapis.com/css?family=Nunito:200,300,400');

html
  box-sizing border-box

*, *:before, *:after
  box-sizing inherit

html, body
  height: 100%

body
  height 100%
  font-family 'Nunito', sans-serif
  width 100%
  padding-top 20px

#app
  // font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
  height 100%

article
  border-radius border-radius
  color #fff
  height 100%
  position relative
  header
    padding 0 padding * 2
    .offset
      transform translate(0, -2px)

    .name
      display inline-block
      margin-left margin
      vertical-align middle
      h2
        font-size 18px
        font-weight 400
  .content
    background-color rgba(255,255,255,0.15)
    height calc(100% - 50px)

button
  color inherit
  font-family inherit
  font-size 14px
  font-weight 300

.avatar
  border-radius 50%
  height 50px
  overflow hidden
  width 50px
  img
    height 100%
    width 100%

.tooltip
  display block !important
  font-size 10px
  padding 8px
  padding-bottom 16px
  z-index 10000

  .tooltip-inner
    background #2c3e50
    color white
    border-radius 2px
    padding 4px

  .tooltip-arrow
    bottom 10px
    border-style solid
    border-width 6px 6px 0 6px
    border-color #2c3e50 transparent transparent transparent
    height 0
    position absolute
    width 0

  &[aria-hidden='true']
    visibility hidden
    opacity 0
    transition opacity .15s, visibility .15s

  &[aria-hidden='false']
    visibility visible
    opacity 1
    transition opacity .15s

.split-view
  display flex
  flex-direction column
  height 100%
  max-height 100%
  .split-view-top
    flex 1
    overflow: auto

.clearfix:after
  content ""
  display table
  clear both

.button-group-left
  float left
.button-group-right
  float right

footer
  form
    padding 5px padding * 1.5 padding padding * 1.5
    input[type="text"],
    input[type="email"],
    textarea
      border none
      border-radius border-radius
      font-size 14px
      outline none
      padding padding
      padding-right 48px
      vertical-align top
      width 100%
    .field
      position relative
      & + .field
        margin-top margin
      .actions
        margin-top 0
        position absolute
        right 0
        top 7px
        button
          background none
          border none
          border-radius border-radius
          color #999
          display inline-block
          font-size 20px
          height 38px
          margin-right 5px
          outline none
          padding 8px
          text-align center
          vertical-align middle
          width 38px
          &:hover
            background-color #eee
            
      &.gdpr
        font-size 12px
        padding-left 18px
        line-height 14px
        label
          display block
          input[type="checkbox"]
            margin-left -18px
            margin-right 5px
          span
            margin-top -5px
        a
          color #fff

    .actions
      margin-top margin
      button
        background #fff
        border none
        border-radius border-radius
        color #2c3e50
        display inline-block
        //height 38px
        outline none
        padding padding
        text-align center
        vertical-align middle
        //width 38px
        &.send-message
          transition all .3s
          padding 0
          &[disabled]:hover
            background-color transparent
        &.submit
          background transparent
          color #fff
          font-weight 400
          transition all .3s
          &:hover
            background-color rgba(255,255,255,.1)
          &[disabled]
            background-color transparent
        &.button-link
          background transparent
          color #fff
          &:hover
            background-color transparent
            span
              text-decoration underline
        span
          display inline-block
          & + i
            margin-left 5px

        i
          & + span
            margin-left 5px
        &:hover
          background-color #eee
    .error
      box-shadow inset 0 0 0 2px rgba(255,0,0,.5) !important

</style>



// WEBPACK FOOTER //
// App.vue?4e616ee1